import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  IconButton,
  Tab,
  Typography,
  useTheme,
} from '@material-ui/core';
import { ITab } from '@room-match/shared-ui-components'; // Remove Close Icon and StyledDiaalog
import CloseIcon from '../Icon/CloseIcon'; // Use talent app level folder CloseIcon and StyleDialog - Jerome
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog'; // Use talent app level folder CloseIcon and StyleDialog - Jerome
import React, { useEffect, useState } from 'react';
import IMedia from 'shared/interfaces/IMedia';
import AudioBin from './AudioBin/AudioBin';
import ImageBin from './ImageBin/ImageBin';
import {
  ActiveTabContainer,
  AddButton,
  BinHeader,
  MainCont,
  SectionCont,
  SelectedContent,
  TabContainer,
  TabHeader,
  TabItem,
} from './MediaBinModal.styles';
import VideoBin from './VideoBin/VideoBin';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { ZoomInTwoTone, ZoomOutTwoTone } from '@material-ui/icons';

interface Props {
  show: boolean;
  close: VoidFunction;
  setSelected: (mediaArr: IMedia[]) => void;
  selected: IMedia[];
  //selected is define as attached media if in attachedMedia mode
  attachedMedia?: boolean;
  showOnly?: ITab['name'][];
  single?: boolean;
  imageOrientation?: 'landscape' | 'portrait';
}

const MediaBinModal: React.FC<Props> = ({
  show,
  close,
  setSelected: addMedia,
  selected: mediaSelected,
  attachedMedia,
  showOnly,
  single,
  imageOrientation,
}) => {
  const theme = useTheme();
  const [selected, setSelected] = useState<IMedia[]>(attachedMedia ? [] : mediaSelected);
  const [zoom, setzoom] = useState(false);
  const { width } = useWindowDimensions();

  const handleAdd = () => {
    addMedia(selected);
    close();
  };

  const handleDelete = () => {
    const selectedID = selected.map((m) => m.id);
    const filtered = mediaSelected.filter((f) => selectedID.indexOf(f.id) === -1);
    addMedia(filtered);
    close();
  };

  const handleAddMedia = (media: IMedia) => {
    if (single) return setSelected([media]);
    if (selected.filter((f) => f.id === media.id).length > 0) {
      setSelected((m) => m.filter((f) => f.id !== media.id));
    } else {
      setSelected((m) => [...m, media]);
    }
  };

  const tabs: ITab[] = [
    {
      name: 'image',
      header: 'Images',
      component: (
        <ImageBin
          imageOrientation={imageOrientation}
          zoom={zoom}
          attached={attachedMedia ? true : false}
          media={attachedMedia ? mediaSelected.filter((f) => f.attributes.file_type === 'image') : []}
          addMedia={handleAddMedia}
          selected={selected}
        />
      ),
      disabled: false,
    },
    {
      name: 'video',
      header: 'Videos',
      component: (
        <VideoBin
          attached={attachedMedia ? true : false}
          media={attachedMedia ? mediaSelected.filter((f) => f.attributes.file_type === 'video') : []}
          addMedia={handleAddMedia}
          selected={selected}
        />
      ),
      disabled: false,
    },
    {
      name: 'audio',
      header: 'Audios',
      component: (
        <AudioBin
          attached={attachedMedia ? true : false}
          media={attachedMedia ? mediaSelected.filter((f) => f.attributes.file_type === 'audio') : []}
          addMedia={handleAddMedia}
          selected={selected}
        />
      ),
      disabled: false,
    },
  ];

  const [tab, setTab] = useState(tabs.filter((f) => (showOnly ? showOnly.indexOf(f.name) > -1 : true))[0]?.name);

  const getActiveTab = () => {
    return tabs.find((_tab) => _tab.name === tab)?.component;
  };

  const [expanded, setExpanded] = React.useState<string | false>('');

  const handleChange = (panel: string) => (_: any, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    if ((mediaSelected.filter((f) => f.attributes.file_type === 'video') || []).length) {
      setExpanded('panel2');
    } else if ((mediaSelected.filter((f) => f.attributes.file_type === 'image') || []).length) {
      setExpanded('panel1');
    } else {
      setExpanded('panel3');
    }
  }, [mediaSelected]);

  return (
    <StyledDialog
      fullScreen={width < 960}
      style={{ zIndex: 9999, padding: width < 960 ? 20 : 0 }}
      open={show}
      onClose={close}
      maxWidth={false}
      aria-labelledby="simple-dialog-title"
    >
      <MainCont>
        <CloseIcon style={{ width: 16, alignSelf: 'flex-end', marginBottom: 9, cursor: 'pointer' }} onClick={close} />

        <BinHeader> {`${attachedMedia ? 'Attached Media' : 'Select from Media Bin'}`}</BinHeader>
        <SelectedContent style={{ opacity: single ? 0 : 1 }}>{selected.length} total items selected</SelectedContent>
        {attachedMedia ? (
          <TabContainer>
            {(mediaSelected.filter((f) => f.attributes.file_type === 'video') || []).length ? (
              <Accordion
                expanded={expanded === 'panel2'}
                onChange={handleChange('panel2')}
                style={{
                  backgroundColor: 'transparent',
                  border: theme.palette.type === 'dark' ? 'solid 1px #17212E' : '1px solid #cdd9e9',
                  boxShadow: 'none',
                  borderRadius: 8,
                  marginTop: 10,
                }}
              >
                <AccordionSummary
                  aria-controls="panel2d-content"
                  id="panel2d-header"
                  expandIcon={<ExpandMoreIcon />}
                  style={{ flexDirection: 'row-reverse', padding: '0 10px 0 0' }}
                >
                  <Typography>Videos</Typography>
                  <Typography style={{ color: '#3a81eb', marginLeft: 'auto' }}>
                    {(mediaSelected.filter((f) => f.attributes.file_type === 'video') || []).length}{' '}
                    {(mediaSelected.filter((f) => f.attributes.file_type === 'video') || []).length > 1
                      ? 'videos'
                      : 'video'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <SectionCont>
                    <VideoBin
                      attached={attachedMedia ? true : false}
                      media={attachedMedia ? mediaSelected.filter((f) => f.attributes.file_type === 'video') : []}
                      addMedia={handleAddMedia}
                      selected={selected}
                    />
                  </SectionCont>
                </AccordionDetails>
              </Accordion>
            ) : (
              <></>
            )}
            {(mediaSelected.filter((f) => f.attributes.file_type === 'image') || []).length ? (
              <Accordion
                expanded={expanded === 'panel1'}
                onChange={handleChange('panel1')}
                style={{
                  backgroundColor: 'transparent',
                  border: theme.palette.type === 'dark' ? 'solid 1px #17212E' : '1px solid #cdd9e9',
                  boxShadow: 'none',
                  borderRadius: 8,
                  marginTop: 10,
                }}
              >
                <AccordionSummary
                  style={{
                    flexDirection: 'row-reverse',
                    padding: '0 10px 0 0',
                    border: theme.palette.type === 'dark' ? 'solid 1px #17212E' : '#0f1621',
                  }}
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                  expandIcon={<ExpandMoreIcon />}
                >
                  <Typography style={{ alignSelf: 'center' }}>Images</Typography>
                  {width > 960 ? (
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginLeft: 'auto', opacity: 0.8, marginRight: 10 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setzoom(!zoom);
                      }}
                    >
                      {zoom ? <ZoomOutTwoTone /> : <ZoomInTwoTone />} {zoom ? 'Reduce' : 'Enlarge'} Media
                    </Button>
                  ) : (
                    <></>
                  )}
                  <Typography style={{ color: '#3a81eb', alignSelf: 'center' }}>
                    {(mediaSelected.filter((f) => f.attributes.file_type === 'image') || []).length}{' '}
                    {(mediaSelected.filter((f) => f.attributes.file_type === 'image') || []).length > 1
                      ? 'images'
                      : 'image'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <SectionCont style={{ maxHeight: zoom ? 500 : 230 }}>
                    <ImageBin
                      zoom={zoom}
                      attached={attachedMedia ? true : false}
                      media={attachedMedia ? mediaSelected.filter((f) => f.attributes.file_type === 'image') : []}
                      addMedia={handleAddMedia}
                      selected={selected}
                    />
                  </SectionCont>
                </AccordionDetails>
              </Accordion>
            ) : (
              <></>
            )}
            {(mediaSelected.filter((f) => f.attributes.file_type === 'audio') || []).length ? (
              <Accordion
                expanded={expanded === 'panel3'}
                onChange={handleChange('panel3')}
                style={{
                  backgroundColor: 'transparent',
                  border: theme.palette.type === 'dark' ? 'solid 1px #17212E' : '1px solid #cdd9e9',
                  boxShadow: 'none',
                  borderRadius: 8,
                  marginTop: 10,
                }}
              >
                <AccordionSummary
                  style={{ flexDirection: 'row-reverse', padding: '0 10px 0 0' }}
                  aria-controls="panel3d-content"
                  id="panel3d-header"
                  expandIcon={<ExpandMoreIcon />}
                >
                  <Typography>Audios</Typography>
                  <Typography style={{ color: '#3a81eb', marginLeft: 'auto' }}>
                    {(mediaSelected.filter((f) => f.attributes.file_type === 'audio') || []).length}{' '}
                    {(mediaSelected.filter((f) => f.attributes.file_type === 'audio') || []).length > 1
                      ? 'audios'
                      : 'audio'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <SectionCont>
                    <AudioBin
                      attached={attachedMedia ? true : false}
                      media={attachedMedia ? mediaSelected.filter((f) => f.attributes.file_type === 'audio') : []}
                      addMedia={handleAddMedia}
                      selected={selected}
                    />
                  </SectionCont>
                </AccordionDetails>
              </Accordion>
            ) : (
              <></>
            )}
          </TabContainer>
        ) : (
          <TabContainer>
            <TabHeader
              value={tab}
              // onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              {tabs
                .filter((f) => (showOnly ? showOnly.indexOf(f.name) > -1 : true))
                .map((tab, index) => (
                  <TabItem
                    key={index}
                    label={tab.header}
                    disabled={tab.disabled}
                    value={tab.name}
                    onClick={() => setTab(tab.name)}
                    style={{ textTransform: 'capitalize' }}
                  />
                ))}
              {tab === 'image' ? (
                width > 960 ? (
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: 'auto', opacity: 0.8, marginRight: 10 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setzoom(!zoom);
                    }}
                  >
                    {zoom ? <ZoomOutTwoTone /> : <ZoomInTwoTone />} {zoom ? 'Reduce' : 'Enlarge'} Media
                  </Button>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
            </TabHeader>
            <ActiveTabContainer>{getActiveTab()}</ActiveTabContainer>
          </TabContainer>
        )}
        <AddButton
          variant="contained"
          color="primary"
          onClick={attachedMedia ? handleDelete : handleAdd}
          disabled={selected.length < 1}
        >
          {`${attachedMedia ? 'Delete Selected' : 'Add Media'}`}
        </AddButton>
      </MainCont>
    </StyledDialog>
  );
};

export default MediaBinModal;
